import { Link } from "react-router-dom";
import { Crown, Loader2, AlertTriangle } from "lucide-react";

export const UpgradeCard = ({ feature, plan = "Premium" }) => (
  <div className="card-flat flex flex-col items-start gap-3 p-8" data-testid="upgrade-card">
    <span className="bg-brand inline-flex h-11 w-11 items-center justify-center rounded-xl text-white"><Crown className="h-5 w-5" /></span>
    <h3 className="text-xl font-bold">{feature} avec l'offre {plan}</h3>
    <p className="text-sm text-muted-foreground">Cette fonctionnalité est incluse dans les offres {plan === "Pro" ? "Pro" : "Premium et Pro"}.</p>
    <Link to="/app/offres" data-testid="upgrade-card-link" className="bg-brand mt-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white">Voir les offres</Link>
  </div>
);

export const Generating = ({ label, sub }) => (
  <div className="card-flat flex flex-col items-center px-6 py-16 text-center" data-testid="generating-state">
    <div className="relative">
      <span className="pulse-ring absolute inset-0 rounded-full bg-primary/30" />
      <span className="bg-brand relative inline-flex h-14 w-14 items-center justify-center rounded-full text-white"><Loader2 className="h-6 w-6 animate-spin" /></span>
    </div>
    <p className="mt-6 font-semibold">{label}</p>
    {sub && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{sub}</p>}
  </div>
);

export const ErrorBox = ({ message, action }) => (
  <div className="card-flat flex flex-col items-start gap-3 border-destructive/30 p-6" data-testid="error-box">
    <p className="flex gap-2 text-sm text-destructive"><AlertTriangle className="h-4 w-4 shrink-0" /> {message}</p>
    {action}
  </div>
);
